/** Parses a LinkButton: Control, its own text, uri, underline and overrun_behavior, and BaseButton's disabled and button_pressed, since LinkButton derives from BaseButton, not Button (link_button.cpp:36). */
import { unquoteString, unquoteStringName } from '../../../../parser/utils';
import { parseOptionalInt } from '../../../../parser/valueParsers';
import { parseControl } from '../control/parser';
import { boolSlotValue } from '../../../../godot/variant/variantBool.js';
export function parseLinkButton(heading, properties) {
    const result = { ...parseControl(heading, properties) };
    if (properties.text !== undefined)
        result.text = unquoteString(properties.text);
    if (properties.uri !== undefined)
        result.uri = unquoteString(properties.uri);
    result.underline = parseOptionalInt(properties.underline);
    result.overrunBehavior = parseOptionalInt(properties.text_overrun_behavior);
    // link_button.cpp:93-95: `set_ellipsis_char` keeps only the first character.
    if (properties.ellipsis_char !== undefined) {
        result.ellipsisChar = unquoteStringName(properties.ellipsis_char).slice(0, 1) || undefined;
    }
    result.disabled = boolSlotValue(properties.disabled) === true;
    result.buttonPressed = boolSlotValue(properties.button_pressed) === true;
    return result;
}
//# sourceMappingURL=parser.js.map